<template>
  <div class="review">
      <div class="search">
          <el-input v-model="name" placeholder="客户姓名"></el-input>
          <el-input v-model="phone" placeholder="手机号"></el-input>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="code"
                label="订单号"
                width="200">
            </el-table-column>
            <el-table-column
                prop="name"
                width="150"
                label="车主姓名">
            </el-table-column>
            <el-table-column
               width="150"
                prop="phone"
                label="手机号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="carModelOne"
                label="汽车车型">
                <template slot-scope="scope">
                    {{scope.row.carModelOne+scope.row.carModelTwo}}
                </template>
            </el-table-column>
            <el-table-column
               width="150"
                prop="vin"
                label="车架号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="productName"
                label="产品名称">
            </el-table-column>
            <el-table-column
               width="150"
                prop="saleType"
                label="订单类型">
                <template slot-scope="scope">
                    {{scope.row.saleType == 1 ?'销售':scope.row.saleType == 2?'续费':'销售'}}
                </template>
            </el-table-column>
            <el-table-column
                prop=""
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="modify(scope.row)">编辑</el-link>
                    <el-link :underline="false" @click="deletes(scope.row)" style="color:#F56C6C">删除</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
  </div>
</template>

<script>
import {draftsQuery,getselllist,deletedraft} from '../axios/api'
export default {
    data(){
        return{
            name:'',
            phone:'',
            tableData:[],
            currentPage4: 1,
            total:0,
            page:1,
            states:0
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
            
        },
        deletes(row){
            console.log(row)
            this.$confirm('删除后，数据不可恢复，确认删除吗?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await deletedraft({
                        code:row.code
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getdata()
                    }
                   
                }).catch(() => {
                
            });
        },
        modify(row){
            console.log(row)
            // 从草稿箱进入修改的时候  传递参数1，可以修改产品类型
            let modify = 2
            this.$router.push({
                name:'销售信息录入',
                params:{
                    all:row,
                    modify:modify,
                    draft:true
                }
            })
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await draftsQuery({
                current:this.page,
                limit:10,
               shopId:window.localStorage.getItem('shopId'),
               state:1
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.total
                this.tableData = dt.data.records
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await getselllist({
                name:this.name,
                phone:this.phone,
                state:1,
                current:1,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await getselllist({
                name:this.name,
                phone:this.phone,
                state:1,
                current:this.page,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        }
    }
}

</script>
<style lang="less" scoped>
.review{
   background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    } 
}
</style>
<style>
.el-date-range-picker{
        z-index: 9999999!important;
}
.el-date-range-picker__editors-wrap .el-date-range-picker__time-picker-wrap:nth-child(2){
    display: none;
    /* display: ; */
}
</style>